// initial state
// shape: [{ id, quantity }]
const state = {
  cacheDate: null,
  klines: {
    kline_1m: {
      /* eg: 
        kline+商品id : klineData k线数据,
        kline256 代表商品id为256的商品
         ... 
      */
    },
    kline_3m: {},
    kline_5m: {},
    kline_10m: {},
    kline_15m: {},
    kline_30m: {},
    kline_60m: {},
    kline_2h: {},
    kline_4h: {},
    kline_1d: {},
    kline_1w: {},
    kline_month: {}
  }
}

// getters
const getters = {
}

// actions
const actions = {}

// mutations
const mutations = {
  setCacheDate(state, data) {
    console.log('setCacheDate', data)
    state.cacheDate = data
  },
  setKlineCache(state, data) {
    console.log('setKlineCache', data)
    state.klines = data
  },
  clearKlineCache(state, data) {
    state.cacheDate = null
    state.klines = {
      kline_1m: {
        /* eg: 
          kline+商品id : klineData k线数据,
          kline256 代表商品id为256的商品
           ... 
        */
      },
      kline_3m: {},
      kline_5m: {},
      kline_10m: {},
      kline_15m: {},
      kline_30m: {},
      kline_60m: {},
      kline_2h: {},
      kline_4h: {},
      kline_1d: {},
      kline_1w: {},
      kline_month: {}
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
